import { AllCalendarEntry } from '../schema/AllCalendarEntry';

export const isCalendarEntryForLocalCalendar = (calendarEntry: AllCalendarEntry) =>
    !calendarEntry.IsGroupMailboxCalendar && !!calendarEntry.CalendarFolderId;
